import { LoginModel } from "@app/models/login.model";
import { Unit } from "@app/models/profile.model";

export class Login {
  static readonly type = '[Auth] Login';
  constructor(public payload: LoginModel) { }
}

export class RefreshToken {
  static readonly type = '[Auth] Refresh token';
}

export class Logout {
  static readonly type = '[Auth] Logout';
}

export class ClearAuth {
  static readonly type = '[Auth] Clear Auth';
}

export class SelectUnit {
  static readonly type = '[Auth] Select Unit';
  constructor(public unit: Unit) { }
}

export class SetToken {
  static readonly type = '[Auth] Set Auth';
  constructor(public accessToken: string, public refreshToken: string) { }
}
